import { useMemo } from 'react'

import { AGENT_WARNING_MESSAGES } from './constants'
import type {
  AgentWarningMessage,
  AgentWarningMessageOptions,
  UserWithAvatar,
} from './types'

const hasFilledAvatar = (user: UserWithAvatar): boolean => {
  return typeof user.avatar === 'string' && user.avatar.trim().length > 0
}

const hasFilledPhone = (user: UserWithAvatar): boolean => {
  return typeof user.phone === 'string' && user.phone.trim().length > 0
}

const hasSpokenLanguages = (user: UserWithAvatar): boolean => {
  return Array.isArray(user.spokenLanguages) && user.spokenLanguages.length > 0
}

const hasFilledBiography = (user: UserWithAvatar): boolean => {
  if (!Array.isArray(user.biography) || user.biography.length === 0) {
    return false
  }

  return user.biography.some((entry) => {
    if (typeof entry === 'string') {
      return entry.trim().length > 0
    }

    return (
      typeof entry?.description === 'string' &&
      entry.description.trim().length > 0
    )
  })
}

const hasSocialProfiles = (user: UserWithAvatar): boolean => {
  if (Array.isArray(user.socialContacts) && user.socialContacts.length > 0) {
    return true
  }

  return Array.isArray(user.socialNetworks) && user.socialNetworks.length > 0
}

export const resolveB2BAgentWarningMessage = ({
  user,
  isStaff,
}: AgentWarningMessageOptions): AgentWarningMessage => {
  if (isStaff) {
    return ''
  }

  if (!hasFilledAvatar(user)) {
    return AGENT_WARNING_MESSAGES.avatar
  }

  if (!hasFilledPhone(user)) {
    return AGENT_WARNING_MESSAGES.phone
  }

  if (!hasSpokenLanguages(user)) {
    return AGENT_WARNING_MESSAGES.spokenLanguages
  }

  if (!hasFilledBiography(user)) {
    return AGENT_WARNING_MESSAGES.biography
  }

  if (!hasSocialProfiles(user)) {
    return AGENT_WARNING_MESSAGES.socialProfiles
  }

  return ''
}

export const useB2BAgentWarningMessage = (
  options: AgentWarningMessageOptions
): AgentWarningMessage => {
  return useMemo(() => resolveB2BAgentWarningMessage(options), [options])
}
